export const SLIDESHOW_START_FRAME = 120;
export const NUM_SPIRAL_IMAGES = 24;
export const IMAGES_PER_LOOP = 5;
export const SPIRAL_THETA_OFFSET = (2 * Math.PI) / IMAGES_PER_LOOP;
export const SPIRAL_ROUND_THETA_OFFSET = (2 * Math.PI) / NUM_SPIRAL_IMAGES;
export const SPIRAL_THETA_OFFSET_ROUND_CAP = Infinity;
export const RADIUS_CAP_FACTOR = 1.1;
const BASE_SPIRAL_IMAGE_FACTOR = 250;
export const SHRINK_FACTOR = 50_000;
export const SHRINK_RADIUS_OFFSET = 180;
export const SPIRAL_IMAGE_SIZE = {
	width: BASE_SPIRAL_IMAGE_FACTOR * 90,
	height: BASE_SPIRAL_IMAGE_FACTOR * 120,
};
export const SPIRAL_IMAGE_ASPECT_RATIO = SPIRAL_IMAGE_SIZE.width / SPIRAL_IMAGE_SIZE.height;
export const SPIRAL_ROW_SPACING = 3;
export const SPIRAL_SPIN_SPEED = 0.005;
export const BASE_SPIRAL_CENTER_RADIUS = 50;
export const SPIRAL_SHRINK_MULTIPLIER = 0.000000001;
export const BASE_SPIRAL_SHRINK = 0.6;
export const ACCELERATION_FACTOR = 4.9;
export const TILT_FACTOR = -0.0006;
export const TILT_OFFSET = 0.6;
